import React from 'react';
import { ForbiddenSvg } from './illustrations/forbidden-svg';

interface ForbiddenErrorProps {
  message?: string;
}

export const ForbiddenError: React.FC<ForbiddenErrorProps> = ({ message }) => {
  return (
    <div className="text-center space-y-6 animate-in fade-in zoom-in-95 duration-500">
      {/* Dynamic SVG Illustration */}
      <div className="flex justify-center my-2">
        <ForbiddenSvg />
      </div>

      {/* Heading & Subtitle */}
      <div className="space-y-3 max-w-lg mx-auto">
        <h1 className="text-3xl sm:text-4xl font-extrabold text-slate-900 dark:text-white tracking-tight">
          Access Forbidden...
        </h1>
        <p className="text-slate-500 dark:text-slate-400 text-sm sm:text-base leading-relaxed">
          {message || "You don't have permission to access this resource or page."}
        </p>
      </div>
    </div>
  );
};

export default ForbiddenError;
